import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { Geometry, Point, Polygon } from 'ol/geom';
import { Circle, Fill, Stroke, Style, Text } from 'ol/style';
import { Feature } from 'ol';
import { VesselRs1345Model } from '../models/vessel-rs1345-model';

const _PROJECTION = (<any>window)["appenv"].projection;

export class NavtexLayer extends EventTarget {
    async getStations() {
        const stations = VesselRs1345Model!.getStations();
        return stations;
    }

    private _layer : VectorLayer<VectorSource<Geometry>> | null = null;

    get layers(): VectorLayer<VectorSource<Geometry>>[] {
        return this._layers;
    }

    async initialize(): Promise<void>
    {
        this._vectorSource = new VectorSource();
        this._layer = new VectorLayer({source: this._vectorSource, visible: false});
        this._layers.push(this._layer);
        this.plot();
    }

    private _clear() {
        try {
            this._vectorSource!.clear();
        } catch (error) {
            console.warn(error);
        }
    }

    enable() {
        this.plot().then(() => this._layer!.setVisible(true));
    }

    disable() {
        this._layer!.setVisible(false);
        this._clear();
    }

    // Colors are used both for day mode and night mode, so they can be described here
    private _colors: Map<string, string> = new Map([
        ["A", "#a0e3b7"],
        ["B", "#881d2a"],
        ["C", "#a5e841"],
        ["D", "#7212ff"],
        ["E", "#859947"],
        ["F", "#7f73ed"],
        ["G", "#275b52"],
        ["H", "#ddc0bd"],
        ["I", "#5f9b99"],
        ["J", "#dd725e"],
        ["K", "#1cf1a3"],
        ["L", "#e21c7a"],
        ["M", "#48a421"],
        ["N", "#4233a6"],
        ["O", "#ef66f0"],
        ["P", "#3f436d"],
        ["Q", "#e5d75e"],
        ["R", "#a50fa9"],
        ["S", "#4cf32c"],
        ["T", "#fbacf6"],
        ["U", "#3693f2"],
        ["V", "#ba689e"],
        ["W", "#bb8801"],
        ["X", "#fd2b31"],
        ["Y", "#987d7b"],
        ["Z", "#663d20"]
    ]);

    private _layers: VectorLayer<VectorSource<Geometry>>[] = [];
    private _vectorSource: VectorSource<Geometry>|null = null;

    public async plot() {
        this._clear();

        const stations = await this.getStations();
        if (!stations) {
            return;
        }

        const features: Feature<Geometry>[] = [];

        stations!.forEach(station => {
            const borderColor = this._colors.get(station.designator);

            const style = new Style({
                stroke: new Stroke({
                    color: borderColor, width: 2
                })
            });

            const pointStyle = new Style({
                image: new Circle({
                    radius: 3,
                    stroke: new Stroke({color: borderColor, width: 6}),
                    fill: new Fill({color: borderColor})
                }),
                zIndex: 20
            });


            const circleFeature: Feature<Geometry> = new Feature({geometry: new Polygon(<number[][][]>station.geometry!.coordinates)});
            circleFeature.getGeometry()?.transform('EPSG:4326', _PROJECTION);
            circleFeature.setStyle(style);
            

            const pointFeature: Feature<Geometry> = new Feature({geometry: new Point(station.position.coordinates)});
            pointFeature.getGeometry()?.transform('EPSG:4326', _PROJECTION);
            pointFeature.setStyle(pointStyle);
            pointFeature.set('address', station.address);
            pointFeature.set('designator', station.designator);
            pointFeature.set('layer', "Navtex");

            features.push(circleFeature);
            features.push(pointFeature);
        })      

        this._vectorSource!.addFeatures(features);
    }
};
